import { render } from "./ModeratorsList.vue?vue&type=template&id=9fd543a4&scoped=true"
import script from "./ModeratorsList.vue?vue&type=script&lang=js"
export * from "./ModeratorsList.vue?vue&type=script&lang=js"

import "./ModeratorsList.vue?vue&type=style&index=0&id=9fd543a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd543a4"]])

export default __exports__